





























































































































































































































































































import Vue from "vue";
import axios from "axios";
import store from "@/store";
import router from "@/router";
import kykyviisari from "@/interfaces/kykyviisari";
import KykyviisariGraphs from "@/modals/KykyviisariGraphs.vue";
import { format, parseISO } from "date-fns";

export default Vue.extend({
	components: {
		KykyviisariGraphs
	},
	data() {
		return {
			kykyviisarit: [] as kykyviisari[],
			orgGuid: "",
			answerRows: [] as any,
			tableLoading: true as boolean,
			linkLoading: false,
		};
	},
	computed: {
      isMobile() {
         return store.state.isMobile;
      }, 
		storeAuthObject() {
			return this.$store.state.strongAuth;
		},
		storeJwt() {
			return this.$store.state.jwt;
		},
		uniqueGuid() {
			return this.$data.orgGuid;
		},
	},
	methods: {
		goToAbilitator() {
			this.linkLoading = true;
			axios
				.get(`auth/kykyviisari/${this.uniqueGuid}/${this.$store.state.lang}`)
				.then((resp) => {
					window.open(resp.data);
					this.linkLoading = false;
				})
				.finally(() => (this.linkLoading = false));
			// window.open(
			//     `${process.env.VUE_APP_ABILITATOR_URL}/${this.uniqueGuid}`, "_blank");
		},
		formatDate(d: string) {
			return format(parseISO(d), "d.M.yyyy");
		},
		formatPercents(p: number) {
			return p != null ? p.toFixed() + "%" : "-";
		},
		displayCaret(index: number, val: any) {
			if (this.kykyviisarit[index + 1] && val) return true;
			else return false;
		},
		caretColor(val1: any, val2: any) {
			if (val1 && val2 && val1 > val2) {
				return 1;
			} else if (val1 && val2 && val2 > val1) {
				return 2;
			} else return 3;
		},
	},
	mounted() {
		axios
			.get(`itsepalvelu/kykyviisari/orgguid/${this.$store.state.org}`)
			.then((r) => {
				this.orgGuid = r.data.toUpperCase();
			})
			.catch((e) => {
				console.log(e);
			});
		axios.get("Itsepalvelu/kykyviisari/viisarit").then((r) => {
			this.kykyviisarit = r.data;
			this.$data.tableLoading = false;
		});
	},

	watch: {
		storeJwt: {
			handler: async function handle(newVal) {
				if (newVal) {
					try {
						const resp = await axios.get("auth/TestAuth");
						console.log(resp);
					} catch (error) {
						router.push({
							name: "Home",
							params: {
								org: store.state.org as string,
							},
						});
					}
				} else {
					router.push({
						name: "Home",
						params: {
							org: store.state.org as string,
						},
					});
				}
			},
			immediate: true,
		},
	},
});
